"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAdvancedSearchDynamicFilters = useAdvancedSearchDynamicFilters;
const mapAdvancedSearchOpToStringColumnFilter_1 = require("../utils/mapAdvancedSearchOpToStringColumnFilter");
const useAdvancedSearchTextFieldOperatorOptions_1 = require("./useAdvancedSearchTextFieldOperatorOptions");
function useAdvancedSearchDynamicFilters(dynamicColumnData) {
    if (dynamicColumnData) {
        const columnDefs = dynamicColumnData.columnDefs.filter((columnDef) => columnDef.metadata?.showInFilters && ['string', 'string-array', 'id', 'id-array'].includes(columnDef.type));
        if (columnDefs.length > 0) {
            const textFieldOperatorOptions = (0, useAdvancedSearchTextFieldOperatorOptions_1.useAdvancedSearchTextFieldOperatorOptions)();
            const advancedSearchItems = [];
            for (const columnDef of columnDefs) {
                if (columnDef.metadata?.columnHandlerName) {
                    const dynamicColumnLabel = columnDef.metadata?.label ?? '';
                    const dynamicColumnName = `_dynamic_${columnDef.name}`;
                    const { filterOptions } = dynamicColumnData.handlerMap.get(columnDef.metadata.columnHandlerName)?.handler ?? {};
                    if (columnDef.type === 'string' && !filterOptions) {
                        advancedSearchItems.push({
                            label: dynamicColumnLabel,
                            value: dynamicColumnName,
                            operatorOptions: textFieldOperatorOptions,
                            dynamicColumnHandlerName: columnDef.metadata.columnHandlerName,
                            onGetStorageFilter: (operator, value) => {
                                const dynamicColumnFilter = (0, mapAdvancedSearchOpToStringColumnFilter_1.mapAdvancedSearchOpToStringColumnFilter)(dynamicColumnName, operator, value);
                                if (operator.startsWith('not')) {
                                    return {
                                        op: 'or',
                                        filter: [{ column: dynamicColumnName, op: 'is-null' }, dynamicColumnFilter],
                                    };
                                }
                                return dynamicColumnFilter;
                            },
                        });
                    }
                    else if (filterOptions) {
                        advancedSearchItems.push({
                            label: dynamicColumnLabel,
                            value: dynamicColumnName,
                            operatorOptions: textFieldOperatorOptions,
                            dynamicColumnHandlerName: columnDef.metadata.columnHandlerName,
                            onGetStorageFilter: (operator, value) => {
                                let arrayOperation;
                                if (columnDef.type.endsWith('array')) {
                                    if (operator.startsWith('not')) {
                                        arrayOperation = 'contained';
                                    }
                                    else {
                                        arrayOperation = 'overlap';
                                    }
                                }
                                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                const dynamicColumnFilter = {
                                    column: dynamicColumnName,
                                    op: arrayOperation ?? 'in',
                                    subFilter: {
                                        entity: filterOptions.subFilterEntity,
                                        column: filterOptions.subFilterColumn,
                                        filter: [filterOptions.onGetStorageSubFilter(operator, value)],
                                    },
                                };
                                if (operator.startsWith('not')) {
                                    if (columnDef.type.endsWith('array')) {
                                        return {
                                            op: 'or',
                                            filter: [{ column: dynamicColumnName, op: '=', value: [] }, dynamicColumnFilter],
                                        };
                                    }
                                    else {
                                        return {
                                            op: 'or',
                                            filter: [{ column: dynamicColumnName, op: 'is-null' }, dynamicColumnFilter],
                                        };
                                    }
                                }
                                return dynamicColumnFilter;
                            },
                        });
                    }
                    else {
                        console.warn(`DynamicColumnHandler.filterOptions is missing, DynamicColumnHandler=${columnDef.metadata.columnHandlerName}`);
                    }
                }
            }
            return advancedSearchItems;
        }
    }
    return undefined;
}
